import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { setupListeners } from "@reduxjs/toolkit/query";
import AboutUsSlice from "../Redux/Slice/AboutUs.Slice"
import FAQSlice from "./Slice/FAQ.Slice";
import PrivacyPolicySlice from "./Slice/PrivacyPolicy.Slice";
const rootReducer = combineReducers({
    aboutUs:AboutUsSlice,
    FAQ:FAQSlice,
    privacyPolicy:PrivacyPolicySlice,
})

const appReducer = (state, action) => {
    // if (action.type === "CLEAR_STATE") {
    //   state = undefined;
    // }
    return rootReducer(state, action);
  };


  const persistConfig = {
    key: "root",
    storage,
  };

  
  const persistedReducer = persistReducer(persistConfig, appReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

setupListeners(store.dispatch);

export const RootState = store.getState;

export const AppDispatch = () => store.dispatch;

export const persistor = persistStore(store);

export default store;
